<script lang="ts">
    import { logoCKP } from "../assets/index.js";

    interface Props {
        homepage?: boolean;
    }

    let { homepage = false }: Props = $props();

    const email: string = "info@noveotazky.cz";
</script>


    <footer class="w-full py-20" class:bg-footer-homepage={homepage} class:bg-footer={!homepage}>
        <section
            class="container mx-auto flex flex-col items-center gap-12 px-4 text-center text-white lg:flex-row lg:text-left"
        >
            <div class="border-opacity-30 border-white py-6 lg:border-r lg:pr-12">
                <img alt="Logo České kanceláře pojistitelů" class="h-20" src={logoCKP} />
            </div>

            <div class="flex flex-1 flex-col items-center gap-4 lg:items-start">
                <p class="border-opacity-30 max-w-3xl border-b border-white pb-4">
                    Vytvořeno v rámci projektu Nová generace testových otázek pro žadatele o řidičské oprávnění ve formě
                    HAZARD PERCEPTION VIDEOSEKVENCE podpořeného Fondem zábrany škod České kanceláře pojistitelů
                </p>

                <a class="w-max font-bold" href={`mailto:${email}`}>
                    {email}
                </a>
            </div>
        </section>
    </footer>

